import React, { Component } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import {
  PincodeLevellDistributionProps,
  PincodeLevellDistributionState,
} from "../../pincodeLevel/interface";
import { UserHelper } from "../../../../utils";
import { Col, Row, UncontrolledTooltip } from "reactstrap";
import { showToaster, toasterTypes } from "../../../../widgets";
import {
  authenticationService,
  commonService,
  distributionService,
} from "../../../../service";
import { DistributionRow } from "../../pincodeLevel/partials/distributionRow";
import { FieldItem, FIELD_TYPES } from "../../../../widgets/fields";
import { Link } from "react-router-dom";
import { NumericEditor } from "../../../../utils/validation/numeric-cell-editor-validation";

class StateToPINCodeLevelDistribution extends Component<
  PincodeLevellDistributionProps,
  PincodeLevellDistributionState
> {
  static defaultProps = {
    projectName: "",
  };
  constructor(props: PincodeLevellDistributionProps) {
    super(props);
    this.state = {
      modal: false,
      tableData: [],
      distributionQuantity: "",
      remarks: "",
      selectedDistrict: null,
      distributionDate: "",
      gridApi: "",
      tableRecords: [],
      context: {
        componentParent: this,
      },
      rowEditById: 0,
      userData: {},
      pincodeOptions: [],
      selectedPincode: null,
      projectId: "",
      totalQuantity: 0,
      totalDispatched: 0,
      districtOptions: [],
    };
  }
  componentDidMount() {
    const userDetails = UserHelper.getUserDetails();
    this.getDistrictByState(userDetails?.state_id);
    this.getAllSaplingList();
    this.setState({
      userData: userDetails,
      projectId: this.props.projectId,
    });
  }

  componentDidUpdate(prevProps: any) {
    if (prevProps.projectId !== this.props.projectId) {
      this.setState(
        {
          projectId: this.props.projectId,
        },
        () => {
          const userDetails = UserHelper.getUserDetails();
          this.getDistrictByState(userDetails?.state_id);
          if (this.state.selectedDistrict) {
            this.getPincodeLevellDistribution(
              this.state.selectedDistrict.value
            );
          }
        }
      );
    }
  }

  getDistrictByState = (stateId: any) => {
    try {
      authenticationService.getAllDistrictByStateId(stateId, this.props.projectId || "").subscribe(
        (response: any) => {
          try {
            if (response.status && response.statusCode === 200) {
              if (response.data?.length > 0) {
                let rowData: any = response.data.map((element: any) => ({
                  label: element.name,
                  value: element.id,
                }));
                this.setState({ districtOptions: rowData });
              }
            } else {
              showToaster(toasterTypes.ERROR, response.message);
            }
          } catch (error) {
            console.log(error.message);
          }
        },
        (error: any) => {
          console.log(error);
          showToaster(toasterTypes.ERROR, error.message);
        }
      );
    } catch (error) {
      console.log(error?.message);
    }
  };

  getAllSaplingList = () => {
    try {
      commonService
        .getTotalProcuredQuantity(
          this.state.projectId,
          this.state.userData.state_id
        )
        .subscribe(
          (response: any) => {
            if (response.status && response.statusCode === 200) {
              if (response.data) {
                this.setState({
                  totalQuantity: response.data.total_delivered,
                  totalDispatched: response.data.total_dispatched,
                });
              }
            } else {
              showToaster(toasterTypes.ERROR, response.message);
            }
          },
          (error: any) => {
            console.log(error);
            showToaster(toasterTypes.ERROR, error.message);
          }
        );
    } catch (error) {
      console.log(error?.message);
    }
  };

  getPincodeLevellDistribution = (districtId: string) => {
    try {
      distributionService.getAllPincodeDistributionplan(districtId).subscribe(
        (response: any) => {
          try {
            let rowData: any = [];
            if (response.status && response.statusCode === 200) {
              if (
                Array.isArray(response.content) &&
                response.content?.length > 0
              ) {
                rowData = response.content.map((element: any) => ({
                  id: element.id,
                  PincodeId: element.pincode_id,
                  Pincode: element.pincode_name,
                  PlannedQuantity: element.plan,
                  TotalDistributed: element.total_distributed,
                  TotalPlanted: element.total_planted,
                  TotalDistributedCount: element.total_distributed_count,
                }));
                this.setState({ tableRecords: rowData });
              }
            } else {
              showToaster(toasterTypes.ERROR, response.message);
            }
            this.setState({ tableRecords: rowData });
          } catch (error) {
            console.log(error.message);
          }
        },
        (error: any) => {
          console.log(error);
          showToaster(toasterTypes.ERROR, error.message);
        }
      );
    } catch (error) {
      console.log(error?.message);
    }
  };

  handleDistrictChange = (selectedDistrict: any) => {
    this.setState({ selectedDistrict });
    if (selectedDistrict) {
      this.getPincodeLevellDistribution(selectedDistrict.value);
    }
  };

  onGridReady = (params: any) => {
    this.setState({
      gridApi: params.api,
    });
  };

  save = () => {
    this.state.gridApi.stopEditing();
    const requestData: any = [];
    let sumOfPlanned = this.state.tableRecords.reduce(function (prev, current) {
      return prev + +current["PlannedQuantity"];
    }, 0);
    let totalQty = this.state.totalQuantity;
    if (totalQty < sumOfPlanned) {
      showToaster(
        toasterTypes.ERROR,
        "Total Planned Quantity cannot exceed total quantity"
      );
      return false;
    }
    this.state.tableRecords.forEach((element: any) => {
      if (element["PlannedQuantity"] !== null) {
        requestData.push({
          id: element["id"],
          pincode_id: element["PincodeId"],
          pincode_name: element["Pincode"],
          plan: element["PlannedQuantity"],
        });
      }
    });

    if (this.state.selectedDistrict) {
      distributionService
        .savePincodePlan(requestData, this.state.selectedDistrict.value || "")
        .subscribe(
          (data: any) => {
            if (data.status && data.statusCode === 200) {
              if (this.state.selectedDistrict) {
                this.getAllSaplingList();
                this.getPincodeLevellDistribution(
                  this.state.selectedDistrict.value
                );
              }
              showToaster(toasterTypes.SUCCESS, data.message);
            } else {
              showToaster(toasterTypes.ERROR, data.message);
            }
          },
          (error: any) => {
            console.log(error);
            showToaster(toasterTypes.ERROR, error.message);
          }
        );
    }
  };

  cellStyle = (params: any) => {
    return { textAlign: "right" };
  };
  render() {
    return (
      <section id="ViewProject" className="ViewProject">
        <div className="container" data-aos="fade-up">
          <div className="row no-gutters">
            <div className="col-lg-12 d-flex flex-column justify-content-center ">
              <div className="col-lg-12 d-flex flex-column justify-content-center ">
                <Row>
                  <Col md={9}>
                    <h3 className="heading-secondary p-0 m-0 mb-1">
                      Pin Code Level Distribution
                    </h3>
                  </Col>
                  <Col md={2}>
                    <div className="mr-1 card p-1 text-center">
                      <b>{this.state.totalQuantity}</b>
                      <small>Total Delivered Quantity</small>
                    </div>
                  </Col>
                  <Col md={1}>
                    <Link to="/districtLevelDistribution">
                      <i
                        className="fa fa-times  text-dark float-right"
                        id="close"
                      ></i>
                    </Link>
                    <UncontrolledTooltip target={`close`}>
                      Close
                    </UncontrolledTooltip>
                  </Col>
                </Row>
                <h4 className="heading-tertiary">
                  {this.props.projectName} for {this.state.userData.state_name}
                </h4>

                <div className="row">
                  <div className="col-md-8"></div>
                  <div className="col-md-4">
                    <FieldItem
                      onChange={this.handleDistrictChange}
                      label="Area"
                      name="Area"
                      value={this.state.selectedDistrict}
                      options={this.state.districtOptions || []}
                      placeholder="Select Area"
                      type={FIELD_TYPES.DROP_DOWN}
                      className="selectRequired"
                      required
                    />
                  </div>
                </div>

                <div className="section-title">
                  <div className="d-flex align-items-center justify-content-end mb-2 "></div>
                  <div className="grid">
                    <div className="ag-theme-alpine">
                      <AgGridReact
                        domLayout="autoHeight"
                        singleClickEdit={true}
                        context={this.state.context}
                        rowData={this.state.tableRecords}
                        onGridReady={this.onGridReady}
                        frameworkComponents={{
                          DistributedColumn: DistributionRow,
                          numericEditor: NumericEditor,
                        }}
                        enableBrowserTooltips={true}
                        columnTypes={{
                          valueColumn: {
                            valueParser: "Number(newValue)",
                          },
                        }}
                        suppressDragLeaveHidesColumns={true}
                      >
                        <AgGridColumn
                          field="Pincode"
                          headerName="Pin Code"
                          sortable={true}
                          filter={true}
                          tooltipField="Pin Code"
                          suppressMovable={true}
                        />
                        <AgGridColumn
                          field="PlannedQuantity"
                          sortable={true}
                          filter={true}
                          editable={true}
                          cellStyle={this.cellStyle}
                          tooltipField="PlannedQuantity"
                          type="rightAligned"
                          cellEditor="numericEditor"
                          suppressMovable={true}
                        />
                        <AgGridColumn
                          field="Distributions"
                          headerName="Your distributions"
                          cellRenderer="DistributedColumn"
                          cellRendererParams={{
                            projectId: this.props.projectId,
                            districtId: this.state.selectedDistrict?.value,
                            totalDistributed: this.state.totalDispatched,
                            totalQuantity: this.state.totalQuantity,
                          }}
                          suppressMovable={true}
                          cellStyle={{ color: "blue" }}
                        />
                        <AgGridColumn
                          field="TotalDistributed"
                          headerName="Total distributed by you"
                          sortable={true}
                          filter={true}
                          type="rightAligned"
                          tooltipField="TotalDistributed"
                          suppressMovable={true}
                        />

                        <AgGridColumn
                          field="TotalPlanted"
                          headerName="Total planted"
                          sortable={true}
                          filter={true}
                          type="rightAligned"
                          tooltipField="TotalPlanted"
                          suppressMovable={true}
                        />
                      </AgGridReact>
                    </div>
                  </div>
                  {this.state.selectedDistrict?.value && (
                    <div className="text-end p-2">
                      <button
                        onClick={this.save}
                        className="btn Btn_small btn-theme-primary"
                        title="Save"
                      >
                        Save
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default StateToPINCodeLevelDistribution;
